import React from 'react';
import * as css from './whatsapp-button.styles';
import { OLIST_HOST_NAME } from '@plug/config/consts';

type TWhatsAppButtonConfig = {
  hosts: string[];
  url: string;
};

const WHATSAPP_BUTTON_CONFIGS: TWhatsAppButtonConfig[] = [
  {
    hosts: OLIST_HOST_NAME,
    url: 'https://wa.me/554123910136',
  },
];

const hostToWhatsAppUrl = WHATSAPP_BUTTON_CONFIGS.reduce<Record<string, string>>(
  (hostMap, config) => {
    config.hosts.forEach(host => {
      hostMap[host] = config.url;
    });

    return hostMap;
  },
  {},
);

const WhatsAppButton = () => {
  const currentHost = window.location.host;
  const currentHostname = window.location.hostname;
  const href = hostToWhatsAppUrl[currentHost] ?? hostToWhatsAppUrl[currentHostname];
  if (!href) return null;

  return (
    <css.Container
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir conversa no WhatsApp"
    >
      <css.Image
        width="58px"
        height="58px"
        src="https://arquivo.tiny.com.br/gohubbly/images/whatsapp.svg"
        alt="Botão WhatsApp"
      />
    </css.Container>
  );
};

export default WhatsAppButton;
